import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import PedidoService from '../../app/service/PedidoService'

class Pedidos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pedido: null,
      pedidos: [],
      codigo: '',
      nome: '',
      modalPedido: false,
      modalPedidoAlterar: false,
      openSpinner: false,
    }

    this.pedidoService = new PedidoService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroPedidos = this.renderFooterCadastroPedidos.bind(this);
    this.renderFooterAlterarPedidos = this.renderFooterAlterarPedidos.bind(this);
  }

  listarPedidos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.pedidoService.listarPedidos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pedidos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Pedidos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({pedido: null});
    this.setState({nome: ''});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarPedido(rowData)}
                tooltip="Editar Pedido" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Pedido" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(objeto) {
    this.setState({codigo: objeto.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o pedido selecionado?',
        header: 'Exclusão de Tipo de Pedido',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirPedido() {
    this.setState({openSpinner: true});
    this.pedidoService.excluirPedido(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Pedidos', detail:'Tipo de Pedido excluído com sucesso', life: 4000});
        this.listarPedidos();
      });
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirPedido();
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterCadastroPedidos(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarPedido}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarPedidos(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarPedido}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async consultarPedido(pedido){
    this.setState({openSpinner: true});
    this.pedidoService.consultarPedido(pedido.codigo)
      .then(response => {
        this.setState({pedido: response.data});
        this.setState({nome: response.data.nome});
        this.setState({codigo: response.data.codigo});
        this.abrirModaAlterar('modalPedidoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Pedidos', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarPedido = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Pedidos', detail:'Nome do Tipo de Pedido é obrigatório', life: 4000});
      return;
    }
    const pedido = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.pedidoService.cadastrarPedido(pedido)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Pedidos', detail:'Tipo de Pedido cadastrado com sucesso', life: 4000});
        this.fecharModal('modalPedido');
        this.listarPedidos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Pedidos', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarPedido = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Pedidos', detail:'Nme do Tipo de Pedido é obrigatório', life: 4000});
      return;
    }

    const pedido = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.pedidoService.alterarPedido(pedido)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Pedidos', detail:'Tipo de Pedido alterado com sucesso', life: 4000});
        this.fecharModal('modalPedidoAlterar');
        this.listarPedidos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Pedidos', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarPedidos();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Peidos */}
          <Dialog header="Cadastro de Tipos de Pedidos"
                    visible={this.state.modalPedido} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroPedidos('modalPedido')} 
                    onHide={() => this.fecharModal('modalPedido')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomePedido">Nome</label>
                        <InputText id="nomePedido" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Pedidos */}
          <Dialog header="Alterar Tipos de Pedidos"
                    visible={this.state.modalPedidoAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarPedidos('modalPedidoAlterar')} 
                    onHide={() => this.fecharModal('modalPedidoAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomePedidoAlterar">Nome</label>
                        <InputText id="nomePedidoAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-dollar"></i>
                        <span> Tipos de Pedidos</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalPedido')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.pedidos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

Pedidos.contextType = AuthContext;
export default withRouter (Pedidos)